// Angular wrapper
import { createElement } from "react";
import type { Root } from "react-dom/client";
import { createRoot } from "react-dom/client";
import { Widget } from "./components/widget";
import "./global.css";

export interface FeedgetConfig {
  apiKey: string;
  apiUrl?: string;
  orientation?: "left" | "right";
  metadata?: {
    userId?: string;
    version?: string;
    custom?: Record<string, any>;
  };
}

export class FeedgetWidgetAngular {
  private root: Root | null = null;
  private container: HTMLDivElement | null = null;
  private config: FeedgetConfig;

  constructor(config: FeedgetConfig) {
    this.config = config;
  }

  mount(containerElement?: HTMLElement): void {
    // Create container if not provided
    if (!containerElement) {
      this.container = document.createElement("div");
      this.container.id = "feedget-widget-container";
      document.body.appendChild(this.container);
    } else {
      this.container = containerElement as HTMLDivElement;
    }

    // Create React root and render widget
    this.root = createRoot(this.container);
    this.root.render(
      createElement(Widget, {
        apiKey: this.config.apiKey,
        apiUrl: this.config.apiUrl,
        orientation: this.config.orientation,
        metadata: this.config.metadata,
      })
    );
  }

  unmount(): void {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
    if (this.container && this.container.id === "feedget-widget-container") {
      document.body.removeChild(this.container);
      this.container = null;
    }
  }

  updateConfig(newConfig: Partial<FeedgetConfig>): void {
    this.config = { ...this.config, ...newConfig };
    if (this.root && this.container) {
      this.root.render(
        createElement(Widget, {
          apiKey: this.config.apiKey,
          apiUrl: this.config.apiUrl,
          orientation: this.config.orientation,
          metadata: this.config.metadata,
        })
      );
    }
  }
}

// Factory function for easier usage
export function createFeedgetWidget(
  config: FeedgetConfig
): FeedgetWidgetAngular {
  return new FeedgetWidgetAngular(config);
}
